import type { ServiceBillingInvoice } from '@/components/invoices/invoice.types'
import type { DashboardFilter } from './types'

function matchesFilter(invoice: ServiceBillingInvoice, filter: DashboardFilter) {
  if (filter === 'ALL') return true

  if (filter === 'OPEN') {
    return invoice.approvalStatus === 'PENDING_APPROVAL'
  }

  if (filter === 'ARCHIVE') {
    return (
      invoice.status === 'CANCELED' ||
      invoice.approvalStatus === 'REJECTED' ||
      invoice.approvalStatus === 'APPROVED'
    )
  }

  return true
}

function matchesSearch(invoice: ServiceBillingInvoice, searchTerm: string) {
  const q = searchTerm.trim().toLowerCase()
  if (!q) return true

  return [invoice.invoiceNumber, invoice.bankName, invoice.consultantName]
    .filter(Boolean)
    .some(v => v.toLowerCase().includes(q))
}

export function selectVisibleInvoices(
  invoices: ServiceBillingInvoice[],
  filter: DashboardFilter,
  searchTerm: string
) {
  return invoices.filter(i => matchesFilter(i, filter)).filter(i => matchesSearch(i, searchTerm))
}
